<template>
    <div class="spending-card flex column">
        <div v-if="waiting.is" style="height: 55px" class="title flex center space-between">
            <v-skeleton-loader :width="300" type="text" />

            <v-skeleton-loader style="margin-right: 30px" :width="100" type="text" />
        </div>

        <div v-else class="title flex center space-between" :class="{ error: percentage > 100 }">
            <div>
                <span class="title-type">{{ title }}</span>
                <span class="title-text" v-show="percentage <= 100">
                    {{ investiments ? 'você deve poupar' : 'não deve exceder' }}
                    {{ legend }} % do orçamento</span
                >
            </div>

            <div v-if="percentage > 100">O total excede os 100%</div>

            <div class="flex">
                <div class="title-type">{{ incomes | currency }} ({{ budgetValueSomatory.toFixed() }}%)</div>

                <a v-if="!edit && !creation" @click="editBudget"> <edit-icon /> </a>

                <a
                    v-if="edit && !creation"
                    class="icon ion-md-close"
                    :class="{ error: percentage > 100 }"
                    @click="cancelEdition"
                    ><ion-icon name="close"
                /></a>
            </div>
        </div>

        <div v-if="waiting.is" class="contend">
            <div class="hide-border"></div>

            <div v-for="(n, index) in waiting.size" :key="index">
                <div class="border"></div>

                <div class="flex spending center space-between">
                    <v-skeleton-loader type="list_avatar" :types="{ list_avatar: 'avatar' }" />

                    <div class="flex item center space-between">
                        <div class="flex column sub-item center space-between">
                            <div class="flex info-progress-bar space-between">
                                <v-skeleton-loader max-width="150" :width="randomWidth(80)" type="text" />
                                <v-skeleton-loader max-width="110" :width="randomWidth(70)" type="text" />
                            </div>

                            <div style="width: 100%">
                                <div class="progress-bar">
                                    <v-skeleton-loader type="progress" :types="{ progress: 'text' }" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <v-skeleton-loader :width="100" type="text" />
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="contend">
            <div class="hide-border"></div>

            <div v-for="(cat, index) in categories" :key="index">
                <div class="border"></div>

                <div class="flex spending center space-between">
                    <div>
                        <img
                            :src="
                                require('@/assets/img/categories/' +
                                    sanitize(cat.category.group) +
                                    '-' +
                                    categoryDefaultName(cat.category) +
                                    '.png')
                            "
                            class="avatar"
                            :class="[categoryDefaultName(cat.category), cat.category.group]"
                        />
                    </div>

                    <div class="flex item center space-between">
                        <div class="edit-progress-bar flex" v-if="edit">
                            <range-input
                                :label="cat.category.name"
                                :budgetID="cat._id"
                                :hasError.sync="err[index]"
                                :pValue="cat.budgetValue"
                                :maxValue="100"
                                :currentIncome="receitas"
                                @change="updateCategoryBudget"
                            />
                        </div>

                        <div class="flex column sub-item center space-between" v-show="!edit">
                            <div class="flex info-progress-bar space-between" :class="[edit ? 'info-edit' : '']">
                                <h1 class="info-title">{{ cat.category.name }}</h1>

                                <span
                                    class="info-value"
                                    :class="{ active: compareValues(cat.category._id, cat.budgetValue) }"
                                    >{{ spended(cat.category._id) | currency }}
                                </span>
                            </div>

                            <div class="progress-bar-border" :class="[edit ? 'edit' : '']">
                                <div
                                    class="progress-bar"
                                    :class="{ active: compareValues(cat.category._id, cat.budgetValue) }"
                                    :style="{
                                        width:
                                            calcPercentage(
                                                balancesPerCategory(cat.category._id),
                                                calcBudgetValue(cat.budgetValue)
                                            ) + '%',
                                    }"
                                ></div>
                            </div>
                        </div>

                        <div class="spend" :class="[edit ? 'edit' : '']">
                            {{ calcBudgetValue(cat.budgetValue) | currency }}
                        </div>

                        <div class="flex">
                            <a v-if="creation" @click="editBudget(cat)" style="padding: 0px"> <edit-icon /> </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import RangeInput from '../../components/inputs/RangeInput.vue'
import EditIcon from '../icons/EditIcon.vue'

import util from '@/common/util'

export default {
    name: 'SpendingCard',

    components: {
        RangeInput,
        EditIcon,
    },

    props: {
        categoriesList: Array,
        revenues: Number,
        percentage: Number,
        title: String,
        edit: {
            type: Boolean,
            default: false,
        },
        waiting: {
            type: Object,
            default: () => {
                return {
                    is: false,
                }
            },
        },
        // ajustar as props abaixo quando investimentos estiver rodando de fato
        essential: {
            type: String,
            default: 'is',
        },
        investiments: {
            type: Boolean,
            default: false,
        },
        creation: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            receitas: this.revenues,
            categories: [],
            err: null,
            lastRef: null,
        }
    },

    methods: {
        calcPercentage(spend, value) {
            if (value === 0 && spend !== 0) return 100
            else if (this.investiments && spend < 0) return 0
            return (Math.abs(spend) / value) * 100
        },

        calcBudgetValue(budgetValue) {
            return Number((this.revenues * budgetValue * 0.01).toFixed(2))
        },

        spended(category) {
            if (this.investiments) return this.balancesPerCategory(category)
            return Math.abs(this.balancesPerCategory(category))
        },

        compareValues(category, budgetValue) {
            let balance = this.balancesPerCategory(category)

            if (this.investiments) return balance < this.calcBudgetValue(budgetValue)
            return Math.abs(balance) > this.calcBudgetValue(budgetValue)
        },

        sanitize(string) {
            return util.sanitize(string)
        },

        categoryDefaultName(category) {
            return this.sanitize(
                category.group === 'investiments' ? category.name : this.getDefaultCategoryById(category).name
            )
        },

        randomWidth(base) {
            return util.randomWidth(base)
        },

        editBudget(payload) {
            this.$emit('toggleEdition', payload)
        },

        cancelEdition() {
            this.instanceCategoriesList()
            this.$emit('cancelEdition')
        },

        updateCategoryBudget(payload) {
            let otherPayload = {
                category: payload,
            }

            this.lastRef = payload._id
            this.categories.map((category) => {
                if (category._id === payload._id) category.budgetValue = payload.budgetValue
            })

            if (this.essential === 'is') {
                otherPayload.isEssential = true
                otherPayload.essentialSpending = this.budgetValueSomatory
            } else if (this.essential === 'no') {
                otherPayload.isEssential = false
                otherPayload.noessentialSpending = this.budgetValueSomatory
            } else {
                otherPayload.investimentSpending = payload.budgetValue
            }

            this.$emit('updateBudgetEvent', otherPayload)
        },

        // Prevenir warning do Vuex
        instanceCategoriesList() {
            this.categories = []
            this.categoriesList.forEach((category) => {
                this.categories.push({ ...category })
            })
            this.err = Array(this.categoriesList.length).fill(false)
        },
    },

    computed: {
        ...mapGetters(['balancesPerCategory', 'getDefaultCategoryById']),

        budgetValueSomatory() {
            return this.categories.reduce((prevValue, budgetCat) => {
                return prevValue + budgetCat.budgetValue
            }, 0)
        },

        incomes() {
            return this.receitas * this.budgetValueSomatory * 0.01
        },

        legend() {
            if (this.essential === 'is') return 60
            else if (this.essential === 'no') return 40
            return 10
        },
    },

    watch: {
        revenues(r) {
            this.receitas = r
        },

        percentage() {
            if (this.percentage > 100) {
                if (!this.investiments) {
                    let index = this.categoriesList.findIndex((c) => c._id === this.lastRef)

                    this.err[index] = true
                } else {
                    this.err[0] = true // tirar isso quando tiver investimentos de fato!!
                }
            } else {
                this.err.fill(false)
            }
        },

        categoriesList() {
            if (this.categoriesList) this.instanceCategoriesList()
        },
    },

    mounted() {
        if (this.categoriesList) this.instanceCategoriesList()
    },
}
</script>

<style lang="scss" scoped>
.spending-card {
    max-width: 100%;
    margin-bottom: 16px;
}

.spend {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: $blueish-gray;
}

.border {
    box-sizing: border-box;
    border: 1px solid #eef1f6;
}

.range-input {
    position: relative;
    margin-right: 20px;
}

.edit-progress-bar {
    width: 100%;
    position: relative;
}

.hide-border {
    position: absolute;
    top: 0px;
    width: 100%;
    height: 5px;
    background-color: white;
}

.spending {
    padding: 20px 0;
}

.info-progress-bar {
    width: 100%;
    margin-bottom: 8px;

    .info-title {
        font-size: 16px;
        line-height: 18px;
        color: #4a4a4a;
    }
    .info-value {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        text-align: right;
        color: $light-blue;

        &.active {
            color: $expense-red;
        }
    }
}

.info-edit {
    padding-right: 56px;
}

.range-input-container {
    width: 100%;
    padding-right: 56px;
}

.progress-bar-border {
    height: 10px;
    width: 100%;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.15);
    position: relative;

    .progress-bar {
        max-width: 100%;
        height: 100%;
        border-radius: 5px;
        background-color: $btn-blue;
        animation: fill ease-in-out 1s;
        transition: width 0.5s ease;

        &.active {
            background-color: $expense-red;
        }

        @keyframes fill {
            0% {
                max-width: 0;
            }
            100% {
                max-width: 100%;
            }
        }
    }
}

.contend {
    padding: 0 24px 0 23px;
    border-radius: 0 0 2px 2px;
    background-color: #ffffff;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.1);
    font-size: 16px;
    line-height: 19px;
    position: relative;
}

.title {
    padding: 16px 16px 16px 20px;
    border-radius: 2px 2px 0 0;
    background-color: $list-blue;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    color: $blueish-gray;

    &.error {
        background-color: $expense-red;
        color: white;
    }

    .title-type {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
    }

    .title-text {
        font-size: 10px;
        line-height: 13px;
        margin-left: 8px;
    }

    .ion-md-close {
        color: #bbbcbf;
    }

    .icon.error {
        color: white;
    }
}

.item {
    width: 100%;
    padding-left: 16px;

    .sub-item {
        width: 80%;
        margin-right: 16px;
    }
}

.edit {
    display: none;
}

.center {
    align-items: center;
}

.flex-center {
    justify-content: center;
}

.space-between {
    justify-content: space-between;
}

.row {
    flex-direction: row;
}

.flex {
    display: flex;
}

.column {
    flex-direction: column;
}

a {
    color: #848484;
    font-size: 25px;
    padding-left: 20px;
}

span {
    font-size: 13px;
    line-height: 14px;
}

img {
    height: 30px !important;
    width: 30px !important;
    border-radius: 50%;
    vertical-align: middle;
}
</style>
